export default {
  created () {
    this._listenters = []
  },
  methods: {
    $addEventListener (target, type, listener, options) {
      target.addEventListener(type, listener, options)
      this._listenters = this._listenters.concat({
        target, type, listener, options
      })
    },
    $removeEventListener (target, type, listener, options) {
      target.removeEventListener(type, listener, options)
      this._listenters = this._listenters.filter(data => {
        return !(data.target === target && data.type === type && data.listener === listener)
      })
    },
    $removeEventListenersByCondition (fn) {
      this.$removeEventListeners(this._listenters.filter(fn))
    },
    $removeEventListeners (listenters = this._listenters) {
      listenters.forEach(({target, type, listener, options}) => this.$removeEventListener(target, type, listener, options))
    }
  },
  beforeDestroy () {
    this.$removeEventListeners()
    this._listenters = null
  }
}



// WEBPACK FOOTER //
// ./src/mixin/listener.js